import { Button } from 'antd';
import classNames from 'classnames';
import styles from '../styles.module.less';
import { PlayCircleOutlined, PauseOutlined, SyncOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

export const ActionButtons = ({ onRefresh, pauseButton, isPaused, resumeTime, pauseTime }) => {
  return (
    <div className="gx-flex-row gx-align-items-center gx-gap-1">
      <Button
        onClick={() => onRefresh(true)}
        className={classNames(styles.manualRefreshButton, 'gx-m-0')}
        icon={<SyncOutlined />}
      />
      {pauseButton && (
        <Button
          onClick={() => (isPaused ? resumeTime() : pauseTime())}
          className={classNames(styles.manualRefreshButton, 'gx-m-0')}
          icon={isPaused ? <PlayCircleOutlined /> : <PauseOutlined />}
        />
      )}
    </div>
  );
};

ActionButtons.propTypes = {
  onRefresh: PropTypes.func.isRequired,
  pauseButton: PropTypes.bool,
  isPaused: PropTypes.bool,
  resumeTime: PropTypes.func,
  pauseTime: PropTypes.func,
};
